import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import PDFViewer from "./PDFViewer";
import PDFViewerInvoice from "./PDFViewerInvoice";
import PDFViewLabSheet from "./PDFViewLabSheet";
import PDFViewerCashFlow from "./PDFViewerCashFlow";
import PDFViewerIncomeExpense from "./PDFViewerIncomeExpense";
import PDFViewerAnnualIncomeExp from "./PDFViewerAnnualIncomeExp";
const PDFViewerDialog = ({
  reportNo,
  labRequestId,
  open,
  handleCloseReportPreview,
  reportType,
  letterHead,
  jobId,
  month,
  year,
  monthName,
}) => {
  return (
    <div>
      <Dialog
        fullWidth
        open={open}
        maxWidth="xl"
        onClose={handleCloseReportPreview}
        aria-labelledby="responsive-dialog-title"
        sx={{ width: "100%" }}
      >
        <Divider />
        <DialogContent>
          <div>
            {reportType === "REPORT" ? (
              <PDFViewer
                reportNo={reportNo}
                labRequestId={labRequestId}
                letterHead={letterHead}
              />
            ) : reportType === "INVOICE" ? (
              <PDFViewerInvoice
                reportNo={reportNo}
                labRequestId={labRequestId}
                jobId={jobId}
              />
            ) : reportType === "LABSHEET" ? (
              <PDFViewLabSheet
                reportNo={reportNo}
                labRequestId={labRequestId}
                jobId={jobId}
              />
            ) : reportType === "CASHFLOW" ? (
              <PDFViewerCashFlow
                reportNo={reportNo}
                date={labRequestId}
                jobId={jobId}
              />
            ) : reportType === "INCOMEEXPENSEMONTHWISE" ? (
              <PDFViewerIncomeExpense
                reportNo={reportNo}
                date={labRequestId}
                jobId={jobId}
                year={year}
                month={month}
                monthName={monthName}
              />
            ) : reportType === "ANNUALINCOMEEXPENSE" ? (
              <PDFViewerAnnualIncomeExp
                reportNo={reportNo}
                date={labRequestId}
                jobId={jobId}
              />
            ) : (
              ""
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PDFViewerDialog;
